var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',_vm._b({staticClass:"label-chip mr-1 mt-1",class:[_vm.customClass]},'v-chip',_vm.resetProps,false),[_c('span',[_vm._v(" "+_vm._s(_vm.text))]),(!_vm.noIcon)?_c('span',{staticClass:"label-chip-icon",on:{"click":_vm.iconClickHandler}},[_c('v-icon',{attrs:{"size":"8"}},[_vm._v(_vm._s(_vm.icon))])],1):_vm._e()])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }